import { PageContentProps } from "../../../../types";
import useComponentGeneralStyles from "../../../styles";

const PageContent = (props: PageContentProps) => {
    const { children } = props;
    const generalStyles = useComponentGeneralStyles();
    
    

    return (
        <div className="my-4 mx-md-1 mx-md-5" style={{ ...generalStyles.pageContent }}>
            {children}
        </div>
    );
};

export default PageContent;
